<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="dropdown-item date-item mt-4">
        <div class="date-grid">
          <div class="date-search-container">
            <div class="row p-1">
              <div class="col-md-2 form-group">
                <label for="startDate">Date</label>
                <input
                  type="date"
                  v-model="startDate"
                  class="search-input"
                  :max="currentDate"
                />
              </div>
              <div class="col-md-2 form-group d-flex align-items-end">
                <label for="startDate">&nbsp;</label>
                <button class="btn button-default" @click="search">Search</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="loading-spinner mt-3">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <div v-if="stockData.length" class="mt-4">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th rowspan="2">Item Name</th>
                <th rowspan="2">Yard Stock</th>
                <th v-for="vehicle in vehicleNumbers" :key="vehicle" colspan="1">
                  {{ vehicle }}
                </th>
                <th rowspan="2">Total</th>
              </tr>
              <tr>
                <th v-for="vehicle in vehicleNumbers" :key="'sub_' + vehicle">
                  Current Stock
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in stockData" :key="index">
                <td>{{ item.item_name }}</td>
                <td>{{ item.yard_stock || 0 }}</td>
                <td v-for="vehicle in vehicleNumbers" :key="'stock_' + vehicle">
                  {{ item[vehicle]?.current_stock || 0 }}
                </td>
                <td><strong>{{ calculateTotalStock(item) }}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { vehicelwisestockrepoet } from "@/services/dataService";

export default {
  data() {
    return {
      startDate: new Date().toISOString().split("T")[0],
      currentDate: new Date().toISOString().split("T")[0],
      loading: false,
      stockData: [],
      vehicleNumbers: [],
    };
  },
  methods: {
    async search() {
      this.loading = true;
      const token = localStorage.getItem("token_set");
      const profileId = localStorage.getItem("profile_id");

      if (!token || !profileId) {
        alert("Authentication token or profile ID is missing!");
        this.loading = false;
        return;
      }

      const payload = { distributor_id: profileId, date: this.startDate };

      try {
        const response = await vehicelwisestockrepoet(payload, token);
        if (response.data.status === "success") {
          this.stockData = response.data.data;
          this.vehicleNumbers = this.getUniqueVehicleNumbers(response.data.data);
        } else {
          alert("Failed to fetch data");
        }
      } catch (error) {
        console.error("API Error:", error);
        alert("Error fetching stock data");
      } finally {
        this.loading = false;
      }
    },

    getUniqueVehicleNumbers(data) {
      let vehicles = new Set();
      data.forEach((item) => {
        Object.keys(item).forEach((key) => {
          if (key !== "item_name" && key !== "yard_stock") {
            vehicles.add(key);
          }
        });
      });
      return Array.from(vehicles);
    },

    calculateTotalStock(item) {
      let yardStock = parseFloat(item.yard_stock) || 0;
      let currentStockTotal = this.vehicleNumbers.reduce(
        (sum, vehicle) => sum + (parseFloat(item[vehicle]?.current_stock) || 0),
        0
      );
      return yardStock + currentStockTotal;
    },
  },
};
</script>

<style scoped>
/* Card Style */
.card {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Form Group */
.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  margin-bottom: 8px;
  color: #1b2a50;
}

/* Date Picker */
input[type="date"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
}

/* Button */
.button-default {
  padding: 8px 16px;
  background: #015cbe;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.button-default:hover {
  background: #0056b3;
}

/* Loading Spinner */
.loading-spinner {
  text-align: center;
  font-size: 18px;
  color: #007bff;
}

/* Table Styles */
.table-responsive {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background: #abadaf;
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-group {
    width: 100%;
  }
}
</style>
